import React from "react";
import styles from "./IndividualPerformanceMetrices.module.scss";
import DynamicTableFilters from "../../../../common/AdminCommonComponents/DynamicTableFilters/DynamicTableFilters";
import DynamicDatatable from "../../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable";
import { picksPerformanceTableData } from "../../../../../views/AdminPortal/dummyData";
import ActionButton from "../../../../common/AdminCommonComponents/Buttons/ActionButton/ActionButton";

const IndividualPerformanceMetrices = () => {
    const options = [
        { label: "View details" },
        { label: "Edit" },
        { label: "Delete" },
    ];

    const columns = [
        {
            name: "Sr.",
            selector: (_, index) => index + 1,
            center: "true",
            width: "80px",
        },
        {
            name: "Pick ID",
            selector: (row) => row.pickId,
            center: "true",
        },
        {
            name: "Product Name",
            selector: (row) => row.productName,
            center: "true",
            width: "150px"
        },
        {
            name: "Seller ID",
            selector: (row) => row.sellerId,
            center: "true",
        },
        {
            name: "Clicks",
            selector: (row) => row.clicks,
            center: "true",
        },
        {
            name: "Views",
            selector: (row) => row.views,
            center: "true",
        },
        {
            name: "Conversion Rate",
            selector: (row) => row.conversionRate,
            center: "true",
            width: "180px"
        },
        {
            name: "Sales",
            selector: (row) => row.sales,
            center: "true",
        },
        {
            name: "Revenue",
            selector: (row) => row.revenue,
            center: "true",
        },
        {
            name: "Average Order Value",
            selector: (row) => row.aov,
            center: "true",
            width: "200px"
        },
        {
            name: "Actions",
            cell: () => <ActionButton options={options} />,
            center: "true",
        },
    ];

    const handleApply = (filters) => {
        console.log("Applied Filters:", filters);
    };

    const handleClear = () => {
        console.log("Filters Cleared");
    };

    return (
        <div className={styles.individualPerformanceContainer}>
            <div className={styles.filterTableWrapper}>
                <h5 className={styles.sectionHeading}>Picks Performance Metrices</h5>
                <DynamicTableFilters
                    componentName={"Picks Performance Metrics"}
                    onApply={handleApply}
                    onClear={handleClear}
                />
                <div className={styles.tableWrapper}>
                    <DynamicDatatable
                        data={picksPerformanceTableData}
                        columns={columns}
                        type="gray"
                        pagination
                        highlightOnHover
                        responsive
                    />
                </div>
            </div>
        </div>
    );
};

export default IndividualPerformanceMetrices;